import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './CarListing.css';

const CarListingPage = () => {
  // State for cars and filter values
  const [cars, setCars] = useState([]);
  const [filteredCars, setFilteredCars] = useState([]);
  const [brand, setBrand] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  // Fetch cars from the server
  const fetchCars = async () => {
    try {
      const response = await axios.get('https://cardealer-backend-shac.onrender.com/api/cars');
      setCars(response.data);
      setFilteredCars(response.data); // Initialize filteredCars with all cars
    } catch (error) {
      console.error('Error fetching cars:', error);
    }
  };

  useEffect(() => {
    // Fetch cars when the component mounts
    fetchCars();
  }, []);

  // Toggle between light and dark themes
  const toggleTheme = () => {
    setIsDarkTheme(!isDarkTheme);
    document.body.classList.toggle('dark-theme');
  };

  // Filter function to apply the filters and update the filteredCars state
  const handleFilter = () => {
    let filtered = cars;

    // Filter by brand
    if (brand) {
      filtered = filtered.filter((car) =>
        car.brand && car.brand.toLowerCase().includes(brand.toLowerCase())
      );
    }

    // Filter by price range
    if (minPrice) {
      filtered = filtered.filter((car) =>
        car.price !== undefined && car.price >= parseInt(minPrice)
      );
    }
    if (maxPrice) {
      filtered = filtered.filter((car) =>
        car.price !== undefined && car.price <= parseInt(maxPrice)
      );
    }

    setFilteredCars(filtered);
  };

  return (
    <div className="car-listing-page">

      <div className="content-container">
        <div className="car-cards-container">
          <h2>Available Cars</h2>
          <div className="car-cards">
            {filteredCars.length > 0 ? (
              filteredCars.map((car) => (
                <div key={car._id} className="car-card">
                  <Link to={`/cars/${car._id}`} className="car-link">
                    <div className="car-image-container">
                      {car.images && car.images.length > 0 ? (
                        <img src={car.images[0]} alt={`${car.make} ${car.model}`} />
                      ) : (
                        <img src="/path/to/default-image.jpg" alt="Default" />
                      )}
                      {car.available && <span className="availability-badge">AVAILABLE</span>}
                    </div>
                    <div className="car-content">
                      <div className="car-header">
                        <span className="car-year">{car.year}</span>
                        <h3 className="car-title">{car.make} {car.model}</h3>
                      </div>
                      <div className="car-tags">
                        <span className="car-tag">Automatic</span>
                        <span className="car-tag">{car.engineSize} CC</span>
                        <span className="car-tag">{car.condition}</span>
                      </div>
                      <p className="car-description">{car.description}</p>
                      <p className="car-price">KES {car.price}</p>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <p>No cars available</p>
            )}
          </div>
        </div>

        <div className="filter-container">
          <h3>Filter by:</h3>
          <div className="filter-input">
            <label>Min Price:</label>
            <input
              type="number"
              value={minPrice}
              onChange={(e) => setMinPrice(e.target.value)}
              placeholder="Min price"
            />
          </div>
          <div className="filter-input">
            <label>Max Price:</label>
            <input
              type="number"
              value={maxPrice}
              onChange={(e) => setMaxPrice(e.target.value)}
              placeholder="Max price"
            />
          </div>
          <button onClick={handleFilter} className="filter-button">Apply Filter</button>
        </div>
      </div>
    </div>
  );
};

export default CarListingPage;
